import React, { Component } from 'preact';

interface IFullStarsProps {
    naRatingValue: any;
    reviewScheme: any;
    ratingTypes: any;
    setTypeValueAndRating: any;
    checkActiveTypeValue: any;
    showLabels: boolean;
    error: any;
    isOverallRating: boolean;
}

class FullStars extends Component<IFullStarsProps> {

    renderRatings = () => {
        const { reviewScheme, ratingTypes } = this.props;

        if (!ratingTypes.length) {
            return null;
        }

        let ratingValues = reviewScheme.RatingValues || [];

        ratingValues = ratingValues.filter((value: any) => value.Value).filter((e: any, i: number) => e.Value % 1 === 0);

        const { naRatingValue, showLabels, error, isOverallRating } = this.props;

       return (
            <>
                { 
                    ratingTypes.map((type: any, typeKey: number) => {
                        const naActive = naRatingValue ? this.props.checkActiveTypeValue(type.RatingTypeID, naRatingValue.Value) ? 'active' : '' : '';
                        const ratingError = isOverallRating ? error(type.RatingTypeID) : error(type.RatingTypeID, 'ReviewRatingOverall');

                        return (
                            <div className="review-star-rating-container" key={`RatingType${typeKey}`}>
                                <div className="review-star-rating align-items-center">
                                    {
                                        showLabels
                                        ?
                                        <span className={`review-star-rating__type d-flex align-items-center ${ratingError ? 'text-danger': ''}`}>
                                            { type.Name }
                                            {
                                                ratingError
                                                ? <img className="error" src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23F64E60' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23F64E60' stroke='none'/%3e%3c/svg%3e" alt=""/>
                                                : ''
                                            }
                                        </span>
                                        : ''
                                    }
                                    {
                                        type.isAllowedNA && naRatingValue
                                        ?
                                        <div className="review-star-rating__group p-0" key="rating-group-na">
                                            <div
                                                className="review-star-rating__group__container"
                                                key="value-na"
                                                onClick={() => this.props.setTypeValueAndRating(type.RatingTypeID, naRatingValue.Value, naRatingValue.RatingValueID)}
                                            >
                                                <label
                                                    htmlFor={`${type.Name.replace(/ /g, '-')}-${naRatingValue.Name.replace(/ /g, '-')}-na`}
                                                    className={`review-star-rating__group__na ${naActive} btn btn-sm btn-default`}
                                                >
                                                    { naRatingValue.Name }
                                                </label>
                                            </div>
                                        </div>
                                        : ''
                                    }
                                    {
                                        ratingValues.map((value: any, index: number) => {
                                            const activeClass = this.props.checkActiveTypeValue(type.RatingTypeID, value.Value) ? 'active' : '';
                                            return (
                                                <div className="review-star-rating__group" key={`rating-group-${index}`}>                                                  
                                                    <div
                                                        className={`review-star-rating__group__container btn btn-default align-items-center d-flex btn-sm ${activeClass}`}
                                                        key={`value-${index}`}
                                                        onClick={() => this.props.setTypeValueAndRating(type.RatingTypeID, value.Value, value.RatingValueID)}
                                                    >
                                                        <label htmlFor={`${type.Name.replace(/ /g, '-')}-${value.Name.replace(/ /g, '-')}-${index}`}>
                                                            <i className={`fa fa-star review-star-rating__group__icon ${activeClass}`}></i>
                                                        </label>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </>  
       );
    }

    render() {
        return this.renderRatings();
    }
}

export default FullStars;
